import { MsalAuthenticationTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { apiConfig, loginRequest } from "../../authConfig";
/*import toast, { Toaster } from 'react-hot-toast';*/

// Sample app imports
import { Loading } from "../../components/Loading";
import { ErrorComponent } from "../../components/ErrorComponent";
import { GlobalContext } from "../../utils/GlobalContext";
import { SetStateAction, useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortUp, faSortDown, faSort } from '@fortawesome/free-solid-svg-icons';
import { duotone, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Center, AuthActionLookup, AuthDenialReasonLookup, Client, AuthorizationStatus, PayorInfoType, VwCenterAuthorization, AuthFeedbackLookup } from "../../utils/Definitions";
import Select, { MultiValue } from "react-select";
import ProtectedPage from "../../utils/ProtectedPage";
import { AuthorizationModal } from "../../components/authorizations/AuthorizationModal";


const AuthorizationsContent = () => {

    const globalContext = useContext(GlobalContext);
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const [selectedClient, setSelectedClient] = useState<Client | null>(null);
    const [selectedClientId, setSelectedClientId] = useState<number | null>(null);
    const [selectedAuthId, setSelectedAuthId] = useState<string | null>(null);
    const [selectedAuthPayorType, setSelectedAuthPayorType] = useState<string | null>(null);
    const [isMyCentersChecked, setIsMyCentersChecked] = useState<boolean>(false);
    const [isAuthorizationModalActive, setIsAuthorizationModalActive] = useState<boolean>(false);
    const [selectedCenter, setSelectedCenter] = useState<Center | null>();

    const [payorInfoTypes, setPayorInfoTypes] = useState<PayorInfoType[]>([]);
    const [authorizationStatuses, setAuthorizationStatuses] = useState<AuthorizationStatus[]>([]);
    const [centerAuthorization, setCenterAuthorization] = useState<VwCenterAuthorization[]>([]);
    const [authorizationsDue, setAuthorizationsDue] = useState<VwCenterAuthorization[]>([]);
    const [authorizationsPastDue, setAuthorizationsPastDue] = useState<VwCenterAuthorization[]>([]);
    const [authorizationActionsDue, setAuthorizationActionsDue] = useState<VwCenterAuthorization[]>([]);
    const [authDenialReasons, setAuthDenialReasons] = useState<AuthDenialReasonLookup[]>([]);
    const [authFeedbackOptions, setAuthFeedbackOptions] = useState<AuthFeedbackLookup[]>([]);
    const [authActions, setAuthActions] = useState<AuthActionLookup[]>([]);

    function NavigateBack() {
        navigate(-1);
    }


    const OnModalClose = () => {
        setSelectedClientId(null);
        setSelectedAuthId(null);
        setSelectedAuthPayorType(null);
        setSelectedClient(null);
        setIsAuthorizationModalActive(false);

        //update the current auth data on page
        GetCenterAuthorizations();
    }

    const HandleAuthorizationClick = (authId: string, authPayorType:string, clientId: number) => {
        setSelectedAuthId(authId);
        setSelectedAuthPayorType(authPayorType);
        setSelectedClientId(clientId);
    }

    useEffect(() => {
        if (selectedClientId) {
            setIsAuthorizationModalActive(true);
            GetClientById();
        }

    }, [selectedClientId, selectedAuthId]);

    useEffect(() => {

        if (isMyCentersChecked) {

            /*Remove this after it is good for a little while*/
            /*setAuthorizationsDue(centerAuthorization
                .filter(x => {
                    const isInitialAssessment = x.initialAssessment === true;

                    const hasValidDueDate = x.reportDueDate !== null && (() => {
                        const dueDate = new Date(x.reportDueDate!);
                        return dueDate.getTime() !== 0 && !isNaN(dueDate.getTime());
                    })();

                    const isIncluded =
                        x.payorName?.toLowerCase().includes("mi medicaid") &&
                        x.action === "Interim Report Due";

                    return (
                        (x.centerId === selectedCenter?.centerId &&
                        x.reportCompleted === false &&
                            (isInitialAssessment || hasValidDueDate)) ||
                        (x.centerId === selectedCenter?.centerId &&
                        x.reportCompleted === false &&
                        (isInitialAssessment || hasValidDueDate) &&
                        isIncluded)
                    );
                })
                .sort((a, b) => new Date(a.reportDueDate ?? 0).getTime() - new Date(b.reportDueDate ?? 0).getTime())
            );*/

            const MIN_DATE = new Date(0); // Unix epoch (1970-01-01). Use this as "min date".

            const initialList = centerAuthorization
                .filter(x => {
                    const isInitialAssessment = x.initialAssessment === true;
                    const hasValidDueDate = x.reportDueDate !== null && (() => {
                        const dueDate = new Date(x.reportDueDate!);
                        return dueDate.getTime() !== 0 && !isNaN(dueDate.getTime());
                    })();

                    return (
                        x.centerId === selectedCenter?.centerId &&
                        x.reportCompleted === false &&
                        (isInitialAssessment || hasValidDueDate)
                    );
                })
                .map(x => ({ ...x, displayMode: "normal", reportDueDate: x.initialAssessment ? new Date(MIN_DATE) : x.reportDueDate })); 

            const includedList = centerAuthorization
                .filter(x => {
                    const isInitialAssessment = x.initialAssessment === true;
                    const hasValidDueDate = x.reportDueDate !== null && (() => {
                        const dueDate = new Date(x.reportDueDate!);
                        return dueDate.getTime() !== 0 && !isNaN(dueDate.getTime());
                    })();

                    const isIncluded =
                        x.payorName?.toLowerCase().includes("mi medicaid") &&
                        x.action === "Interim Report Due" &&
                        x.actionCompleted === false;

                    return (
                        x.centerId === selectedCenter?.centerId &&
                        x.reportCompleted === false &&
                        (isInitialAssessment || hasValidDueDate) &&
                        isIncluded
                    );
                })
                .map(x => ({ ...x, displayMode: "interim", reportDueDate: x.actionDueDate })); 

            // Combine & sort
            setAuthorizationsDue(
                [...initialList, ...includedList].sort(
                    (a, b) =>
                        new Date(a.reportDueDate ?? 0).getTime() -
                        new Date(b.reportDueDate ?? 0).getTime()
                )
            );



            setAuthorizationActionsDue(
                centerAuthorization
                    .filter(x => {
                        if (!x.actionDueDate) return false;

                        const dueDate = new Date(x.actionDueDate);
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        const isExcluded =
                            x.payorName?.toLowerCase().includes("mi medicaid") &&
                            x.action === "Interim Report Due";

                        return (
                            //dueDate >= today && This was removed because they want them to stay on there until marked as complete
                            x.action !== "Determination Accepted" &&
                            x.actionCompleted !== true &&
                            x.centerId === selectedCenter?.centerId &&
                            x.reportCompleted === false &&
                            !isExcluded
                        );
                    })
                    .sort((a, b) => {
                        const aDate = a.actionDueDate ? new Date(a.actionDueDate).getTime() : Infinity;
                        const bDate = b.actionDueDate ? new Date(b.actionDueDate).getTime() : Infinity;
                        return aDate - bDate;
                    })
            );

            setAuthorizationsPastDue(
                centerAuthorization
                    .filter(x => {
                        const endDate = x.endDate ? new Date(x.endDate) : null;
                        return (
                            endDate !== null &&
                            endDate > new Date() &&
                            x.reportCompleted === true &&
                            x.centerId === selectedCenter?.centerId
                        );
                    })
                    .sort((a, b) => {
                        const aDate = a.reportDueDate ? new Date(a.reportDueDate) : new Date(8640000000000000); // Max Date
                        const bDate = b.reportDueDate ? new Date(b.reportDueDate) : new Date(8640000000000000);
                        return aDate.getTime() - bDate.getTime();
                    })
            );
        }
        else {

            /*Remove this after it is good for a little while*/
            /*setAuthorizationsDue(centerAuthorization
                .filter(x => {
                    const isInitialAssessment = x.initialAssessment === true;

                    const hasValidDueDate = x.reportDueDate !== null && (() => {
                        const dueDate = new Date(x.reportDueDate!);
                        return dueDate.getTime() !== 0 && !isNaN(dueDate.getTime());
                    })();

                    const isIncluded =
                        x.payorName?.toLowerCase().includes("mi medicaid") &&
                        x.action === "Interim Report Due";

                    return (
                        ((x.podmanager === globalContext.CoreAccount.currentUser?.therapistID ||
                            x.authorizedBcbaid === globalContext.CoreAccount.currentUser?.therapistID) &&
                        x.reportCompleted === false &&
                            (isInitialAssessment || hasValidDueDate)) ||
                        ((x.podmanager === globalContext.CoreAccount.currentUser?.therapistID ||
                            x.authorizedBcbaid === globalContext.CoreAccount.currentUser?.therapistID) &&
                        x.reportCompleted === false &&
                        (isInitialAssessment || hasValidDueDate)
                        && isIncluded)
                    );
                })
                .sort((a, b) => new Date(a.reportDueDate ?? 0).getTime() - new Date(b.reportDueDate ?? 0).getTime())
            );*/

            const MIN_DATE = new Date(0); // Unix epoch (1970-01-01). Use this as "min date".

            const currentUserId = globalContext.CoreAccount.currentUser?.therapistID;

            const initialList = centerAuthorization
                .filter(x => {
                    const isInitialAssessment = x.initialAssessment === true;

                    const hasValidDueDate = x.reportDueDate !== null && (() => {
                        const dueDate = new Date(x.reportDueDate!);
                        return dueDate.getTime() !== 0 && !isNaN(dueDate.getTime());
                    })();

                    return (
                        (x.podmanager === currentUserId || x.authorizedBcbaid === currentUserId) &&
                        x.reportCompleted === false &&
                        (isInitialAssessment || hasValidDueDate)
                    );
                })
                .map(x => ({ ...x, displayMode: "normal", reportDueDate: x.initialAssessment ? new Date(MIN_DATE) : x.reportDueDate })); 

            const includedList = centerAuthorization
                .filter(x => {
                    const isInitialAssessment = x.initialAssessment === true;

                    const hasValidDueDate = x.reportDueDate !== null && (() => {
                        const dueDate = new Date(x.reportDueDate!);
                        return dueDate.getTime() !== 0 && !isNaN(dueDate.getTime());
                    })();

                    const isIncluded =
                        x.payorName?.toLowerCase().includes("mi medicaid") &&
                        x.action === "Interim Report Due" &&
                        x.actionCompleted === false;

                    return (
                        (x.podmanager === currentUserId || x.authorizedBcbaid === currentUserId) &&
                        x.reportCompleted === false &&
                        (isInitialAssessment || hasValidDueDate) &&
                        isIncluded
                    );
                })
                .map(x => ({ ...x, displayMode: "interim", reportDueDate: x.actionDueDate })); 

            setAuthorizationsDue(
                [...initialList, ...includedList].sort(
                    (a, b) =>
                        new Date(a.reportDueDate ?? 0).getTime() -
                        new Date(b.reportDueDate ?? 0).getTime()
                )
            );


            setAuthorizationActionsDue(
                centerAuthorization
                    .filter(x => {
                        if (!x.actionDueDate) return false;

                        const dueDate = new Date(x.actionDueDate);
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        const isExcluded =
                            x.payorName?.toLowerCase().includes("mi medicaid") &&
                            x.action === "Interim Report Due";


                        return (
                            dueDate >= today &&
                            x.action !== 'Determination Accepted' &&
                            (
                                x.podmanager === globalContext.CoreAccount.currentUser?.therapistID ||
                                x.authorizedBcbaid === globalContext.CoreAccount.currentUser?.therapistID
                            ) &&
                            x.actionCompleted !== true &&
                            x.reportCompleted === false &&
                            !isExcluded
                        );
                    })
                    .sort((a, b) => {
                        const aDate = a.actionDueDate ? new Date(a.actionDueDate).getTime() : Infinity;
                        const bDate = b.actionDueDate ? new Date(b.actionDueDate).getTime() : Infinity;
                        return aDate - bDate;
                    })
            );

            setAuthorizationsPastDue(
                centerAuthorization
                    .filter(x => {
                        const endDate = x.endDate ? new Date(x.endDate) : null;

                        return (
                            endDate !== null &&
                            endDate > new Date() &&
                            x.reportCompleted === true &&
                            (
                                x.podmanager === globalContext.CoreAccount.currentUser?.therapistID ||
                                x.authorizedBcbaid === globalContext.CoreAccount.currentUser?.therapistID
                            )
                        );
                    })
                    .sort((a, b) => {
                        const aDate = a.reportDueDate ? new Date(a.reportDueDate) : new Date(8640000000000000); // Max date
                        const bDate = b.reportDueDate ? new Date(b.reportDueDate) : new Date(8640000000000000);
                        return aDate.getTime() - bDate.getTime();
                    })
            );
        }

    }, [isMyCentersChecked, selectedCenter, centerAuthorization]);

    useEffect(() => {
        GetPayorInfoTypes();
        GetAuthorizationStatuses();
        GetCenterAuthorizations();
        GetDenialReasons();
        GetAuthActions();
        GetAuthFeedbackOptions();
    }, []);

    // Put sorting functionality here

    type SortDirection = 'asc' | 'desc';

    const [actionsDueSortConfig, setActionsDueSortConfig] = useState<{
        key: keyof VwCenterAuthorization | null;
        direction: SortDirection;
    }>({ key: null, direction: 'asc' });

    const [reportsDueSortConfig, setReportsDueSortConfig] = useState<{
        key: keyof VwCenterAuthorization | null;
        direction: SortDirection;
    }>({ key: null, direction: 'asc' });

    const [reportsCompleteSortConfig, setReportsCompleteSortConfig] = useState<{
        key: keyof VwCenterAuthorization | null;
        direction: SortDirection;
    }>({ key: null, direction: 'asc' });

    const toDateOrNull = (v: unknown): Date | null => {
        if (v == null) return null;                    // null/undefined
        if (typeof v === "string" && v.trim() === "") return null; // empty string
        const d = new Date(v as any);
        return Number.isNaN(d.getTime()) ? null : d;   // invalid date → null
    };

    const isOnOrBeforeToday = (v: unknown): boolean => {
        const d = toDateOrNull(v);
        if (!d) return false;                          // exclude null/invalid
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        d.setHours(0, 0, 0, 0);
        return d.getTime() <= today.getTime();
    };

    // Generic sorting function
    const sortData = (
        data: any[],
        config: { key: string | null; direction: "asc" | "desc" }
    ) => {
        if (!config.key) return data; // no sorting if no key selected
        return [...data].sort((a, b) =>
            compareValues(a[config.key!], b[config.key!], config.direction)
        );
    };

    const compareValues = (a: any, b: any, dir: "asc" | "desc") => {
        const mult = dir === "asc" ? 1 : -1;
        const da = toDateOrNull(a);
        const db = toDateOrNull(b);
        if (da || db) {
            if (!da && !db) return 0;
            if (!da) return 1 * mult;  // nulls last
            if (!db) return -1 * mult;
            return (da.getTime() - db.getTime()) * mult;
        }
        if (a == null && b == null) return 0;
        if (a == null) return 1 * mult;
        if (b == null) return -1 * mult;
        if (typeof a === "string" && typeof b === "string") return a.localeCompare(b) * mult;
        return (a < b ? -1 : a > b ? 1 : 0) * mult;
    };

    // Click handler for sorting
    const handleSort = (table: any, key: any) => {
        if (table === "actionsDue") {
            setActionsDueSortConfig(prev => ({
                key,
                direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
            }));
        } else if (table === "reportsDue") {
            setReportsDueSortConfig(prev => ({
                key,
                direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
            }));
        } else if (table === "reportsComplete") {
            setReportsCompleteSortConfig(prev => ({
                key,
                direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
            }));
        }
    };

    // Sorted data (memoized so it only changes when data/config changes)
    const sortedActionsDue = useMemo(
        () => sortData(authorizationActionsDue, actionsDueSortConfig),
        [authorizationActionsDue, actionsDueSortConfig]
    );


    const sortedReportsDue = useMemo(
        () => sortData(authorizationsDue, reportsDueSortConfig),
        [authorizationsDue, reportsDueSortConfig]
    );

    const sortedReportsComplete = useMemo(
        () => sortData(authorizationsPastDue, reportsCompleteSortConfig),
        [authorizationsPastDue, reportsCompleteSortConfig]
    );

    // Icons
    function getSortIcon(columnKey: string, sortConfig: { key: string | null; direction: 'asc' | 'desc' }) {
        if (sortConfig.key !== columnKey) {
            return faSort; // neutral icon if not sorted by this column
        }
        return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
    }


    function GetClientById() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Clients/GetClientByID?clientId=" + selectedClientId;
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setSelectedClient(result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetClientByID" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetCenterAuthorizations() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };
            setIsLoading(true);
            var url = apiConfig.apiEndpoint + "/Credentials/GetAllCenterAuthorizations";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setCenterAuthorization(result);
                        setIsLoading(false);
                    },
                    (error) => {
                        //setLoading(false);
                        setIsLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAllCenterAuthorizations" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetPayorInfoTypes() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetPayorInfoTypes";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setPayorInfoTypes(result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetPayorInfoTypes" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    /* Get payor status  authorizationStatus*/

    function GetAuthorizationStatuses() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");

            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthorizationStatuses";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthorizationStatuses(result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthorizationStatuses" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetDenialReasons() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthDenialReasonLookup";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthDenialReasons(result);
                    },
                    (error) => {
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthDenialReasonLookup" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetAuthFeedbackOptions() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthFeedbackLookup";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthFeedbackOptions(result);
                    },
                    (error) => {
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthFeedbackLookup" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetAuthActions() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");

            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthActionLookup";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthActions(result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthActionLookup" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    

    return (

        <div className="grid grid-rows-auto ml-auto mr-auto">

            <div className="grid grid-cols-1 h-fit mt-0 mb-8">

                <div onClick={NavigateBack} className="my-2 flex items-center justify-center w-fit cursor-pointer col-span-2">
                    <div className="flex-1">
                        <FontAwesomeIcon className="w-8 h-8 mr-auto align-middle" icon={solid('arrow-left')} />
                    </div>
                    <span className="text-xl w-auto ml-3">Back</span>
                    <div className="flex-1"></div>
                </div>

                <div className={"grid grid-flow-row grid-cols-1 " + (isLoading ? 'hidden' : '')}>

                    <div className="grid grid-cols-1 gap-4 xl:gap-[4.5rem] content-between xl:w-fit xl:m-auto">

                        <div className="grid grid-cols-1 h-fit w-800 p-5 mx-auto">

                            {/*<div className="w-full xl:w-[16rem] m-auto">
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <span className="ml-3 text-sm font-medium">My Authorizations</span>
                                    <input type="checkbox" onChange={event => setIsMyCentersChecked(event.target.checked)} checked={isMyCentersChecked} className="sr-only peer" />
                                    <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                    <span className="ml-3 text-sm font-medium">Center Authorizations</span>
                                </label>
                            </div>*/}

                            <div className="grid-cols-2 w-full m-auto">
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        onChange={(event) => setIsMyCentersChecked(event.target.checked)}
                                        checked={isMyCentersChecked}
                                        className="sr-only peer"
                                    />
                                    <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                    <span className="ml-3 text-sm font-medium">Center Authorizations</span>
                                </label>

                                {isMyCentersChecked && (
                                    <div className="w-full mb-4">
                                        <label className="font-bold" htmlFor="pods">
                                            Center:
                                        </label>
                                        <Select
                                            options={globalContext.lockdownCenters}
                                            onChange={setSelectedCenter}
                                            value={selectedCenter}
                                        />
                                    </div>
                                )}
                            </div>


                            <div className="w-full ml-auto p-2 border-2 border-lacblue rounded-lg">
                                <div className="w-full flex items-center justify-between">

                                    <h2 className="text-2xl text-lacblue w-fit">Actions Due</h2>

                                </div>

                                <div className="max-h-96 overflow-y-auto">
                                    <table className="table-auto w-full">
                                        <thead className="w-full border border-lacblue-500">
                                            <tr className="bg-lacblue text-white hover:cursor-pointer">
                                                <th onClick={() => handleSort("actionsDue", "firstName")}>Learner <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('firstName', actionsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("actionsDue", "centerName")}>Center <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('centerName', actionsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("actionsDue", "payorName")}>Payor <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('payorName', actionsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("actionsDue", "payorInfoType")}>Payor Type <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('payorInfoType', actionsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("actionsDue", "podmanagerName")}>Pod Manager <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('podmanagerName', actionsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("actionsDue", "action")}>Action <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('action', actionsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("actionsDue", "actionDueDate")}>Action Due <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('actionDueDate', actionsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("actionsDue", "utilizationPercentage")}>Util % <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('utilizationPercentage', actionsDueSortConfig)} /></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Build out dependent on the view */}

                                            {sortedActionsDue.length > 0 ? sortedActionsDue.map(authorization =>
                                                <tr className="border border-gray-500 text-center">
                                                    <td className="border border-gray-500 p-2"><span>{authorization.firstName + " " + authorization.lastName}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.centerName ? authorization.centerName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorName ? authorization.payorName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorInfoType ? authorization.payorInfoType : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.podmanagerName ? authorization.podmanagerName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.action ? authorization.action : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.actionDueDate ? new Date(authorization.actionDueDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className={"border border-gray-500 p-2 " + (authorization.utilizationPercentage ? (authorization.utilizationPercentage >= 90 && authorization.utilizationPercentage <= 104) ? "bg-lacgreen-200" : "bg-rose-200" : "")}><span>{authorization.utilizationPercentage ? authorization.utilizationPercentage : "N/A"}</span></td>
                                                    <td onClick={e => HandleAuthorizationClick(authorization.authId, authorization.payorInfoType, authorization.clientId)} className="border border-gray-500"><FontAwesomeIcon className="text-center text-lacblue w-7 h-7 m-auto hover:cursor-pointer" icon={solid('circle-info')} ></FontAwesomeIcon></td>
                                                </tr>
                                            ) : <tr><td colSpan={8} className="text-center text-rose">No Authorizations.</td></tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="w-full ml-auto p-2 border-2 border-lacblue rounded-lg mt-4">
                                <div className="w-full flex items-center justify-between">

                                    <h2 className="text-2xl text-lacblue w-fit">All Reports Due</h2>

                                </div>

                                <div className="max-h-96 overflow-y-auto">
                                    <table className="table-auto w-full">
                                        <thead className="w-full border border-lacblue-500">
                                            <tr className="bg-lacblue text-white hover:cursor-pointer">
                                                <th onClick={() => handleSort("reportsDue", "firstName")}>Learner <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('firstName', reportsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsDue", "centerName")}>Center <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('centerName', reportsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsDue", "payorName")}>Payor <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('payorName', reportsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsDue", "payorInfoType")}>Payor Type <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('payorInfoType', reportsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsDue", "podmanagerName")}>Pod Manager <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('podmanagerName', reportsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsDue", "initialAssessment")}>Report Status <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('initialAssessment', reportsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsDue", "reportDueDate")}>Report Due <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('reportDueDate', reportsDueSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsDue", "utilizationPercentage")}>Util % <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('utilizationPercentage', reportsDueSortConfig)} /></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Build out dependent on the view */ }

                                            {sortedReportsDue.length > 0 ? sortedReportsDue.map(authorization =>
                                                /*<tr className="border border-gray-500 text-center">
                                                    <td className="border border-gray-500 p-2"><span>{authorization.firstName + " " + authorization.lastName}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.centerName ? authorization.centerName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorName ? authorization.payorName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorInfoType ? authorization.payorInfoType : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.podmanagerName ? authorization.podmanagerName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.initialAssessment === true ? "Initial Assessment" : authorization.reportDueDate && (new Date(authorization.reportDueDate) > new Date()) ? "Report Due" : "Report Past Due"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.reportDueDate ? authorization.initialAssessment ? "N/A" : new Date(authorization.reportDueDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className={"border border-gray-500 p-2 " + (authorization.utilizationPercentage ? (authorization.utilizationPercentage >= 90 && authorization.utilizationPercentage <= 104) ? "bg-lacgreen-200" : "bg-rose-200" : "")}><span>{authorization.utilizationPercentage ? authorization.utilizationPercentage : "N/A"}</span></td>
                                                    <td onClick={e => HandleAuthorizationClick(authorization.authId, authorization.payorInfoType, authorization.clientId)} className="border border-gray-500"><FontAwesomeIcon className="text-center text-lacblue w-7 h-7 m-auto hover:cursor-pointer" icon={solid('circle-info')} ></FontAwesomeIcon></td>
                                                </tr>*/

                                                <tr className="border border-gray-500 text-center">
                                                    <td className="border border-gray-500 p-2">
                                                        <span>{authorization.firstName + " " + authorization.lastName}</span>
                                                    </td>
                                                    <td className="border border-gray-500 p-2">
                                                        <span>{authorization.centerName ?? "N/A"}</span>
                                                    </td>
                                                    <td className="border border-gray-500 p-2">
                                                        <span>{authorization.payorName ?? "N/A"}</span>
                                                    </td>
                                                    <td className="border border-gray-500 p-2">
                                                        <span>{authorization.payorInfoType ?? "N/A"}</span>
                                                    </td>
                                                    <td className="border border-gray-500 p-2">
                                                        <span>{authorization.podmanagerName ?? "N/A"}</span>
                                                    </td>

                                                    {/* Report Status column */}
                                                    <td className="border border-gray-500 p-2">
                                                        <span>
                                                            {authorization.displayMode === "interim"
                                                                ? "Interim Report"
                                                                : authorization.initialAssessment === true
                                                                    ? "Initial Assessment"
                                                                    : authorization.reportDueDate &&
                                                                        new Date(authorization.reportDueDate) > new Date()
                                                                        ? "Report Due"
                                                                        : "Report Past Due"}
                                                        </span>
                                                    </td>

                                                    {/* Report Due column */}
                                                    <td className="border border-gray-500 p-2">
                                                        <span>
                                                            {authorization.displayMode === "interim"
                                                                ? new Date(authorization.actionDueDate).toLocaleDateString()
                                                                : authorization.reportDueDate
                                                                    ? authorization.initialAssessment
                                                                        ? "N/A"
                                                                        : new Date(authorization.reportDueDate).toLocaleDateString()
                                                                    : "N/A"}
                                                        </span>
                                                    </td>

                                                    <td
                                                        className={
                                                            "border border-gray-500 p-2 " +
                                                            (authorization.utilizationPercentage
                                                                ? authorization.utilizationPercentage >= 90 &&
                                                                    authorization.utilizationPercentage <= 104
                                                                    ? "bg-lacgreen-200"
                                                                    : "bg-rose-200"
                                                                : "")
                                                        }
                                                    >
                                                        <span>{authorization.utilizationPercentage ?? "N/A"}</span>
                                                    </td>

                                                    <td
                                                        onClick={e =>
                                                            HandleAuthorizationClick(
                                                                authorization.authId,
                                                                authorization.payorInfoType,
                                                                authorization.clientId
                                                            )
                                                        }
                                                        className="border border-gray-500"
                                                    >
                                                        <FontAwesomeIcon
                                                            className="text-center text-lacblue w-7 h-7 m-auto hover:cursor-pointer"
                                                            icon={solid("circle-info")}
                                                        />
                                                    </td>
                                                </tr>

                                            ) : <tr><td colSpan={8} className="text-center text-rose">No Authorizations.</td></tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="w-full p-2 border-2 border-lacblue rounded-lg mt-4">
                                <div className="w-full flex items-center justify-between">

                                    <h2 className="text-2xl text-lacblue w-fit">Completed Reports</h2>

                                </div>

                                <div className="max-h-96 overflow-y-auto">
                                    <table className="table-auto w-full">
                                        <thead className="w-full border border-lacblue-500">
                                            <tr className="bg-lacblue text-white hover:cursor-pointer">
                                                <th onClick={() => handleSort("reportsComplete", "firstName")}>Learner <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('firstName', reportsCompleteSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsComplete", "centerName")}>Center <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('centerName', reportsCompleteSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsComplete", "payorName")}>Payor <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('payorName', reportsCompleteSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsComplete", "payorInfoType")}>Payor Type <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('payorInfoType', reportsCompleteSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsComplete", "podmanagerName")}>Pod Manager <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('podmanagerName', reportsCompleteSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsComplete", "action")}>Action <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('action', reportsCompleteSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsComplete", "actionDueDate")}>Action Due <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('actionDueDate', reportsCompleteSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsComplete", "initialAssessment")}>Report Status <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('initialAssessment', reportsCompleteSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsComplete", "reportDueDate")}>Report Due <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('reportDueDate', reportsCompleteSortConfig)} /></th>
                                                <th onClick={() => handleSort("reportsComplete", "utilizationPercentage")}>Util % <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('utilizationPercentage', reportsCompleteSortConfig)} /></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sortedReportsComplete.filter(x => x.status !== "Imported").length > 0 ? sortedReportsComplete.filter(x => x.status !== "Imported").map(authorization =>
                                                <tr className="border border-gray-500 text-center">
                                                    <td className="border border-gray-500 p-2"><span>{authorization.firstName + " " + authorization.lastName}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.centerName ? authorization.centerName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorName ? authorization.payorName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorInfoType ? authorization.payorInfoType : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.podmanagerName ? authorization.podmanagerName : "N/A" }</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.action ? authorization.action : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.actionDueDate ? new Date(authorization.actionDueDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.initialAssessment === true ? "Initial Assessment" : authorization.reportCompleted ? "Report Completed" : "Inactive"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.reportDueDate ? authorization.initialAssessment ? "N/A" : new Date(authorization.reportDueDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className={"border border-gray-500 p-2 " + (authorization.utilizationPercentage ? (authorization.utilizationPercentage >= 90 && authorization.utilizationPercentage <= 104) ? "bg-lacgreen-200" : "bg-rose-200" : "")}><span>{authorization.utilizationPercentage ? authorization.utilizationPercentage : "N/A"}</span></td>
                                                    <td onClick={e => HandleAuthorizationClick(authorization.authId, authorization.payorInfoType, authorization.clientId)} className="border border-gray-500"><FontAwesomeIcon className="text-center text-lacblue w-7 h-7 m-auto hover:cursor-pointer" icon={solid('circle-info')} ></FontAwesomeIcon></td>
                                                </tr>
                                            ) : <tr><td colSpan={8} className="text-center text-rose">No Authorizations.</td></tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>

                    </div>

                    <AuthorizationModal Client={selectedClient} AuthId={selectedAuthId} AuthPayorType={selectedAuthPayorType} PayorInfoTypes={payorInfoTypes} AuthorizationStatuses={authorizationStatuses} AuthorizationDenialReasons={authDenialReasons} AuthorizationFeedbackOptions={authFeedbackOptions} AuthorizationActions={authActions} Active={isAuthorizationModalActive} setActive={setIsAuthorizationModalActive} OnModalClose={OnModalClose} IsInsurance={false}></AuthorizationModal>
                </div>

                {/* loading here */}
                <div className={"w-full h-auto flex " + (isLoading ? "" : "hidden")}>
                    <FontAwesomeIcon className="fill-current text-lacblue w-24 h-24 animate-spin m-auto" icon={solid('spinner')} />
                </div>

            </div>
        </div>
    );

}

export function Authorizations() {

    const authRequest = {
        ...loginRequest
    };

    return (
        <>

            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest} errorComponent={ErrorComponent} loadingComponent={Loading}>
                <ProtectedPage RequiredRoles={['Authorizations.AppAccess']}>
                    <AuthorizationsContent />
                </ProtectedPage>

            </MsalAuthenticationTemplate>

            <UnauthenticatedTemplate>

            </UnauthenticatedTemplate>

        </>
    );
}